<script setup>
import {
    formataCnpj,
    formataMoedaReais,
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Pessoa Jurídica" :conteudo="props.solicitacao.dados.pessoa_juridica_razao_social"
        :detalhe="props.solicitacao.dados.pessoa_juridica_cnpj ? `CNPJ: ${formataCnpj(props.solicitacao.dados.pessoa_juridica_cnpj)}` : ''" />

    <LabelDados titulo="Valor" :conteudo="props.solicitacao.dados.valor ? formataMoedaReais(props.solicitacao.dados.valor) : 'Não informado'" />

    <LabelDados titulo="Justificativa" v-if="props.solicitacao.dados.justificativa"
        :conteudo="props.solicitacao.dados.justificativa" tamanho_div="col-12" />

</template>